import { render, staticRenderFns } from "./MarketingCampaignCard.vue?vue&type=template&id=dbe7fd24&"
import script from "./MarketingCampaignCard.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignCard.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignCard.vue?vue&type=style&index=0&id=dbe7fd24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports